import axios from "axios";
import swal from "sweetalert2";

export default {
	name: "login",
	data() {
		return {
			maintenance: false,
			form: {
				username: "",
				password: "",
			},
		};
	},
	methods: {
		swalMessage(title, text) {
			swal.fire({
				title: title,
				text: text,
				timer: 3000,
				showConfirmButton: false,
				showCancelButton: false,
			});
		},
		getPricingTableByID: async function () {
			if (process.env.VUE_APP_DEBUG_MODE == true) {
				console.log("Get Pricing Table By ID");
				console.log(this.$store.getters.getAccount.company_pricing);
			}
			const pricing_data = {
				pricing_id: this.$store.getters.getAccount.company_pricing,
			};
			await axios({
				method: "POST",
				url: process.env.VUE_APP_API_URL + "pricing/view",
				headers: {
					authorization: process.env.VUE_APP_API_AUTH,
					"content-type": "application/json",
				},
				data: pricing_data,
			})
				.then((response) => {
					let data = JSON.parse(response.data.data[0].table);
					if (process.env.VUE_APP_DEBUG_MODE == true) {
						console.log("Response Get Data Pricing Table ");
						console.log(data);
					}
					this.$store.commit("setPricing", data);
					if (data.length) { 
					} else {
						swal.fire({
							title: "Error",
							text: "No Default Pricing Table ;O",
							timer: 3000,
							showConfirmButton: false,
							showCancelButton: false,
						});
					}
				})
				.catch((e) => {
					if (process.env.VUE_APP_DEBUG_MODE == true) {
						if (e.response) {
							e = e.response.data;
							console.error("Error");
							console.error(e);
						} else {
							console.error("Error");
							console.error(e);
						}
					}
				});

			this.$nextTick(() => {
				this.$forceUpdate(); 
			});
		},
		login: async function () {
			const clients_data = {
				email: this.form.username,
				password: this.form.password,
			};

			await axios({
				method: "POST",
				url: process.env.VUE_APP_API_URL + "user/login",
				headers: {
					authorization: process.env.VUE_APP_API_AUTH,
					"content-type": "application/json",
				},
				data: clients_data,
			})
				.then((response) => { 
					this.$store.commit("setAccount", response.data.data);
					this.$store.commit("setState", true);
  this.getPricingTableByID();
					this.$router.push("/dashboard");
				})
				.catch((e) => {
					if (e.response) {
						this.swalMessage("Authentication Error", JSON.stringify(e.response.data.message));
					} else {
						this.swalMessage("Authentication Error", e);
					}
					if (process.env.VUE_APP_DEBUG_MODE == true) {
						if (e.response) {
							e = e.response.data;
							console.error(e);
						} else {
							console.error(e);
						}
					}
				});
		},
	},
};
